module.exports = __webpack_public_path__ + "static/media/wheel-stopped.37f94fd8.mp3";